import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8f72c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-tabs m-b-8" }
const _hoisted_2 = {
  key: 1,
  class: "selected-tab header-cursor"
}
const _hoisted_3 = { class: "wrapper" }
const _hoisted_4 = { class: "overview m-b-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Delay Request Count: ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Callback Request Count: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Waiting for Approved: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Waiting for Approved: ", -1))
const _hoisted_9 = { class: "feature-wrap m-b-8" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Request Code", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Request Type", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Request Date", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Status", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dealer Code", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Dealer Name", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Program Code", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Program Name", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Program Type", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " ", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " ", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_23 = { class: "table" }
const _hoisted_24 = { class: "function-btn" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Export")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Reject")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Approve")
const _hoisted_28 = { class: "table-wrap" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "table-pagination" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Send")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " This claim already in checking status，cannot approve this call back. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$btnPermissions('DM0023'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "header-cursor",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.delayRouteJump('/delayCallback/regionCheckRetail')))
          }, " Retail "))
        : _createCommentVNode("", true),
      (_ctx.$btnPermissions('DM0024'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Claim "))
        : _createCommentVNode("", true),
      (_ctx.$btnPermissions('DM0025'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "header-cursor",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.delayRouteJump('/delayUsedCar/regionUC')))
          }, " UC "))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", {
          class: "num",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.quickSearch('1', null)))
        }, _toDisplayString(_ctx.delayRequset), 1),
        _hoisted_6,
        _createElementVNode("span", {
          class: "num",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.quickSearch('2', null)))
        }, _toDisplayString(_ctx.callBackRequset), 1),
        _hoisted_7,
        _createElementVNode("span", {
          class: "num",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.quickSearch('1', '1')))
        }, _toDisplayString(_ctx.delayRequsetApproved), 1),
        _hoisted_8,
        _createElementVNode("span", {
          class: "num",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.quickSearch('2', '1')))
        }, _toDisplayString(_ctx.callBackRequsetApproved), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_a_input, {
              value: _ctx.requestCode,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestCode) = $event)),
              placeholder: "Please input..."
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createVNode(_component_a_select, {
              value: _ctx.requestType,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestType) = $event)),
              style: {"width":"229px"},
              ref: "select",
              placeholder: "Please select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestTypeList, (rt) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: rt.value,
                    key: rt.value,
                    title: rt.title
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(rt.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createVNode(_component_a_date_picker, {
              style: {"width":"229px"},
              value: _ctx.requestDate,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestDate) = $event)),
              placeholder: "Please select..."
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createVNode(_component_a_select, {
              style: {"width":"229px"},
              value: _ctx.status,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.status) = $event)),
              placeholder: "Please select",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (st) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: st.value,
                    key: st.value,
                    title: st.title
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(st.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _createVNode(_component_a_input, {
              value: _ctx.dealerCode,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dealerCode) = $event)),
              placeholder: "Please input..."
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_15,
            _createVNode(_component_a_input, {
              value: _ctx.dealerName,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dealerName) = $event)),
              placeholder: "Please input..."
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _createVNode(_component_a_input, {
              value: _ctx.programCode,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.programCode) = $event)),
              placeholder: "Please input..."
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_17,
            _createVNode(_component_a_input, {
              value: _ctx.programName,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.programName) = $event)),
              placeholder: "Please input..."
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          class: "space"
        }, {
          default: _withCtx(() => [
            _hoisted_18,
            _createVNode(_component_a_select, {
              style: {"width":"229px"},
              value: _ctx.programType,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.programType) = $event)),
              placeholder: "Please select",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programTypeList, (pt) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: pt.id,
                    key: pt.id,
                    title: pt.nameEn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(pt.nameEn), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          style: {"margin-right":"15px"}
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createVNode(_component_a_button, {
              onClick: _ctx.search,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          direction: "vertical",
          size: _ctx.spaceSize,
          style: {"margin-right":"15px"}
        }, {
          default: _withCtx(() => [
            _hoisted_21,
            _createVNode(_component_a_button, { onClick: _ctx.reset }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_a_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, { onClick: _ctx.exportExcel }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.reject
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.approve
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_a_table, {
            class: "ant-table-striped",
            rowClassName: 
            (record, index) => (index % 2 === 1 ? 'table-striped' : null)
          ,
            rowKey: "id",
            columns: _ctx.columns,
            "data-source": _ctx.tableData,
            scroll: {
            x: 1960,
            y: _ctx.tableHeight,
          },
            pagination: false,
            "row-selection": {
            selectedRowKeys: _ctx.selectedRowKeys,
            onChange: _ctx.onSelectChange,
          }
          }, {
            requestType: _withCtx(({ text }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.mapRequestType(text)), 1)
            ]),
            status: _withCtx(({ text }) => [
              _createElementVNode("span", null, _toDisplayString(_ctx.mapStatus(text)), 1)
            ]),
            document: _withCtx(({ record }) => [
              _createElementVNode("span", {
                class: "table-btn",
                onClick: ($event: any) => (_ctx.getDocument(record))
              }, "Supporting Document", 8, _hoisted_29)
            ]),
            failReason: _withCtx(({ record }) => [
              _createElementVNode("span", {
                class: "table-btn",
                onClick: ($event: any) => (_ctx.gotoDetail(record))
              }, "Detail", 8, _hoisted_30)
            ]),
            _: 1
          }, 8, ["rowClassName", "columns", "data-source", "scroll", "row-selection"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(_component_a_pagination, {
        total: _ctx.total,
        "show-total": 
        (total, range) => `${range[0]}-${range[1]} of ${total} items`
      ,
        onChange: _cache[15] || (_cache[15] = (page, pageSize) => _ctx.pageChange(page)),
        onShowSizeChange: _cache[16] || (_cache[16] = (page, pageSize) => _ctx.sizeChange(page, pageSize)),
        "show-size-changer": "",
        current: _ctx.currentPage,
        pageSize: _ctx.pageSize,
        pageSizeOptions: ['10', '20', '30', '40', '50']
      }, null, 8, ["total", "show-total", "current", "pageSize"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        visible: _ctx.rejectModalVisible,
        "onUpdate:visible": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.rejectModalVisible) = $event)),
        title: "Reject Reason"
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.send
          }, {
            default: _withCtx(() => [
              _hoisted_32
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            value: _ctx.rejectReason,
            "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.rejectReason) = $event)),
            placeholder: "Please input...",
            rows: 4
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_a_modal, {
        visible: _ctx.approveModalVisible,
        "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.approveModalVisible) = $event)),
        title: "Warning"
      }, {
        default: _withCtx(() => [
          _hoisted_33
        ]),
        _: 1
      }, 8, ["visible"])
    ])
  ], 64))
}